import { EvPlugTeslaIcon } from './EvPlugTeslaIcon';

/**
 * author: Michael Irigoyen
 * id 04B5C8D6-9732-4D4D-AC1B-0C9ED9E3B8DF
 * name ev-plug-tesla
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ev-plug-tesla.svg
 * tags
 * - Automotive 
 */
export const EvChargerTeslaIcon = EvPlugTeslaIcon;
export default EvChargerTeslaIcon